module.exports = {
  CPF: require("./lib/cpf"),
  CNPJ: require("./lib/cnpj")
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/cpf_cnpj/index.js
// module id = 3294
// module chunks = 1